/* eslint-disable */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";

class AdminNavbar extends Component {
  state = {};

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <a className="navbar-brand" href="#">
          K5 Fitness
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            {this.props.isAdmin ? (
              <li className="nav-item ">
                <Link className="nav-link" to="/admin/orders">
                  Orders
                </Link>
              </li>
            ) : null}

            {this.props.isAdmin ? (
              <li className="nav-item ">
                <Link className="nav-link" to="/admin/staffManagement">
                  Staffs
                </Link>
              </li>
            ) : null}

            <li className="nav-item ">
              <Link className="nav-link" to="/admin/categories">
                Categories
              </Link>
            </li>
            <li className="nav-item">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Products
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <Link className="dropdown-item" to="/admin/products">
                    Add Product
                  </Link>
                  <Link className="dropdown-item" to="/admin/editProduct">
                    Edit Product
                  </Link>
                  {/* <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a> */}
                </div>
              </div>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/admin/homeSections">
                Home Sections
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/admin/brands">
                Brands
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/attributes">
                Attributes
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/admin/collections">
                Collections
              </Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/admin/coupons">
                Coupons
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/workoutPlans">
                Workout
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/carousel">
                Carousel
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/banner">
                Banner
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/client">
                Clients
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/shop">
                Shop
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/stockManagement">
                Stock
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/expiryManagement">
                Expiry
              </Link>
            </li>
            <li className="nav-item float-right mr-0">
              <Link className="nav-link" onClick={this.props.logout}>
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isAdmin: state.auth.admin,
  };
};

const mapDispatchToProps = (disptach) => {
  return {
    logout: () => disptach(actions.logout()),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminNavbar)
);
// export default withRouter(AdminNavbar);
